import { AudienceAutocomplete } from '../../types';
import { JBaseApi } from '../base';
import { OF } from '../../util/network';

export class JAudienceApi extends JBaseApi {
    /**
     * autocomplete
     * return the list of user and Spot
     */
    public autocomplete(query: string): Promise<AudienceAutocomplete[]> {
        return this.network.post({ o: 'autocomplete', f: 'audience', q: query } as OF).then((res) => {
            if (Array.isArray(res.result)) {
                return res.result;
            }
            throw 'Bad response from backend';
        });
    }
}
